"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.runSchedulesUpdater = void 0;
var missing_schedules_error_1 = require("./missing_schedules_error");
function updateSchedulesByExistingRuns(workSchedules, existingRuns, allVehicles, logger) {
    logger = logger || (function () { return null; });
    var defaultTrailersByVehicle = allVehicles.reduce(function (byVehicle, vehicle) {
        if (vehicle.truck_id) {
            byVehicle[vehicle.truck_id] = vehicle.id;
        }
        return byVehicle;
    }, {});
    var unmatchedRuns = fillMissingSchedulesByRuns(workSchedules, existingRuns, defaultTrailersByVehicle, logger);
    clearUnusedSchedules(workSchedules, existingRuns, defaultTrailersByVehicle, logger);
    if (unmatchedRuns.length > 0) {
        throw new missing_schedules_error_1.MissingSchedulesError("could not find any schedule for some of the runs", unmatchedRuns);
    }
}
function fillMissingSchedulesByRuns(workSchedules, runs, defaultTrailersByVehicle, logger) {
    var _a, _b;
    var newResourceId = -1;
    var unmatchedRuns = [];
    var _loop_1 = function (run) {
        var vehicleId = run.vehicle_id;
        var driverId = run.user_id;
        var trailerId = (_b = (_a = run.tasks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.vehicle_id;
        var exactMatches = workSchedules.filter(function (workSchedule) {
            return isScheduleOverlapsWithRun(workSchedule, run) &&
                compare(workSchedule.delivery_block_resource.user_id, driverId) &&
                compare(workSchedule.delivery_block_resource.vehicle_id, vehicleId);
        });
        var matchesByVehicle = exactMatches.length > 0
            ? exactMatches
            : !vehicleId
                ? []
                : workSchedules.filter(function (workSchedule) {
                    return isScheduleOverlapsWithRun(workSchedule, run) &&
                        compare(workSchedule.delivery_block_resource.vehicle_id, vehicleId);
                });
        var matchesByDriver = exactMatches.length > 0
            ? exactMatches
            : !driverId
                ? []
                : workSchedules.filter(function (workSchedule) {
                    return isScheduleOverlapsWithRun(workSchedule, run) &&
                        compare(workSchedule.delivery_block_resource.user_id, driverId);
                });
        if (matchesByVehicle.length === 0 && matchesByDriver.length === 0) {
            unmatchedRuns.push(run);
            return "continue";
        }
        if (exactMatches.length === 0) {
            logger("RunSchedulesUpdater missing schedule for driver [".concat(driverId, "] and vehicle [").concat(vehicleId, "]. filling by ").concat(matchesByVehicle.length > 0 ? 'vehicle' : 'driver', " resource"), { resources: matchesByVehicle.length > 0 ? matchesByVehicle : matchesByDriver });
            exactMatches =
                matchesByVehicle.length > 0
                    ? matchesByVehicle.map(function (matchByVehicle) { return (__assign(__assign({}, matchByVehicle), { delivery_block_resource: __assign(__assign({}, matchByVehicle.delivery_block_resource), { user_id: driverId, id: newResourceId-- }) })); })
                    : matchesByDriver.map(function (matchByDriver) { return (__assign(__assign({}, matchByDriver), { delivery_block_resource: __assign(__assign({}, matchByDriver.delivery_block_resource), { vehicle_id: vehicleId, id: newResourceId-- }) })); });
            for (var _c = 0, exactMatches_1 = exactMatches; _c < exactMatches_1.length; _c++) {
                var exactMatch = exactMatches_1[_c];
                if (!isRunTrailerMatchesSchedule(exactMatch, trailerId, vehicleId, defaultTrailersByVehicle)) {
                    updateTrailer(exactMatch, trailerId, logger);
                }
                workSchedules.unshift(exactMatch);
            }
        }
        else {
            for (var _d = 0, exactMatches_2 = exactMatches; _d < exactMatches_2.length; _d++) {
                var exactMatch = exactMatches_2[_d];
                if (!isRunTrailerMatchesSchedule(exactMatch, trailerId, vehicleId, defaultTrailersByVehicle)) {
                    var exactSchedule = __assign(__assign({}, exactMatch), { delivery_block_resource: __assign(__assign({}, exactMatch.delivery_block_resource), { id: newResourceId-- }) });
                    updateTrailer(exactSchedule, trailerId, logger);
                    workSchedules.unshift(exactSchedule);
                }
            }
        }
    };
    for (var _i = 0, runs_1 = runs; _i < runs_1.length; _i++) {
        var run = runs_1[_i];
        _loop_1(run);
    }
    return unmatchedRuns;
}
function isRunTrailerMatchesSchedule(schedule, runTrailerId, runVehicleId, defaultTrailersByVehicle) {
    return compare(runTrailerId, getTrailerId(schedule, runVehicleId, defaultTrailersByVehicle));
}
function getTrailerId(schedule, runVehicleId, defaultTrailersByVehicle) {
    return schedule.delivery_block_resource.use_default_trailer
        ? defaultTrailersByVehicle[runVehicleId]
        : schedule.delivery_block_resource.trailer_id;
}
function updateTrailer(schedule, runTrailerId, logger) {
    logger("RunSchedulesUpdater mismatch between trailer id on run and resource. filling with ".concat(runTrailerId));
    schedule.delivery_block_resource.trailer_id = runTrailerId;
    schedule.delivery_block_resource.use_default_trailer = false;
}
function clearUnusedSchedules(workSchedules, runs, defaultTrailersByVehicle, logger) {
    if (runs.length === 0) {
        return;
    }
    var removedSchedules = [];
    var _loop_2 = function (i) {
        var deliveryBlockResource = workSchedules[i].delivery_block_resource;
        var runsInDateRange = runs.filter(function (run) { return isScheduleOverlapsWithRun(workSchedules[i], run); });
        var hasExactMatch = runsInDateRange.some(function (run) {
            var _a, _b;
            return compare(run.user_id, deliveryBlockResource.user_id) &&
                compare(run.vehicle_id, deliveryBlockResource.vehicle_id) &&
                compare((_b = (_a = run.tasks) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.vehicle_id, getTrailerId(workSchedules[i], run.vehicle_id, defaultTrailersByVehicle));
        });
        var notRelatedToAnyRun = runsInDateRange.every(function (run) {
            return ((!deliveryBlockResource.user_id || run.user_id !== deliveryBlockResource.user_id) &&
                (!deliveryBlockResource.vehicle_id || run.vehicle_id !== deliveryBlockResource.vehicle_id));
        });
        if (!hasExactMatch && !notRelatedToAnyRun) {
            removedSchedules.push(deliveryBlockResource.id);
            workSchedules.splice(i, 1);
        }
    };
    for (var i = workSchedules.length - 1; i >= 0; i--) {
        _loop_2(i);
    }
    if (removedSchedules.length > 0) {
        logger("RunSchedulesUpdater some resource will not be used, removing.", { resource_ids: removedSchedules });
    }
}
function isScheduleOverlapsWithRun(workSchedule, run) {
    return workSchedule.start <= run.scheduled_end_time && workSchedule.end >= run.scheduled_start_time;
}
function compare(value1, value2) {
    return (value1 !== null && value1 !== void 0 ? value1 : null) === (value2 !== null && value2 !== void 0 ? value2 : null);
}
exports.runSchedulesUpdater = { updateSchedulesByExistingRuns: updateSchedulesByExistingRuns };
//# sourceMappingURL=run_schedules_updater.js.map